import React from 'react';
import { Redirect } from 'react-router-dom';
import { CSVLink } from "react-csv";
import styled from 'styled-components'
import moment from 'moment';
import Details from './Details';
import Tests from './Tests';
import VotSubmissions from './VotSubmissions';
import TreatmentHistory from './TreatmentHistory';
import MoreInformation from './MoreInformation';
import TabView from '../TabView/TabView';
import {baseUrl} from '../url';

const ExportContainer = styled.div`
  padding: 20px;
  background: #FFFFFF;
  -webkit-box-shadow: 0px 1px 3px rgba(63, 63, 68, 0.15), 0px 0px 0px rgba(63, 63, 68, 0.05);
  box-shadow: 0px 1px 3px rgba(63, 63, 68, 0.15), 0px 0px 0px rgba(63, 63, 68, 0.05);
  border-radius: 0 0 3px 3px;
  border-top: 4px solid #685585;
  margin-bottom: 20px;
`;

const ExportButton = styled.button`
    width: 70%;
    font-size: 14px;
    color: #FFFFFF;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: #7C74FE;
    border: 2px dashed #6C63FF;
    box-sizing: border-box;
    border-radius: 3px;
    height: 36px;
    margin-left: 69px;
    margin-top: 20.4px;
    display: flex;
    justify-content: space-between;
`;

const ExportButtonTitle = styled.span`
  font-family: Circular Std;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #FFFFFF;

`;


class DisplayMessage extends React.Component{
    render(){
        return(
            <div className="display-message">
                <p>Please complete <b>Patient's Profile</b> to view {this.props.tab}</p>
            </div>
        )
    }
}

class PatientProfile extends React.Component{
    constructor(){
        super()
        this.state = {
            show: false,
            details: {},
            id: 0,
            noContactPersons: false,
            noTestResult: false,
            newPatient: false,
            point: 0,
            appointmentsNo: 0,
            vots: 0,
            appointments: [],
            pdfData: {},
            csvData: [[]]
        }
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.checkPatientContacts =  this.checkPatientContacts.bind(this);
        this.closeNewAlert =  this.closeNewAlert.bind(this);
        this.closeAlert = this.closeAlert.bind(this);
        this.closeContactsAlert = this.closeContactsAlert.bind(this);
    }
    componentWillMount(){
        window.scrollTo(0, 0);
        let token = localStorage.getItem('access_token'),
            user_id = localStorage.getItem('user_id'),
            user_t = localStorage.getItem('user_type'),
            new_patient = localStorage.getItem('new_patient');
        let retries = 0;
        fetch(`${baseUrl}/admin/users/${user_t}/${user_id}`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            if(response.status === 403){
                localStorage.removeItem('access_token');
                return <Redirect to='/login' />
            }
            return response.json();
        })
        .then((responseJson) => {
            const currentYear = moment();
            const age = currentYear.diff(responseJson.data.bio.dob, 'years');

            this.setState({
                details: responseJson.data,
                id: user_id,
                response: true,
                newPatient: new_patient,
                point: responseJson.data.progress.points,
                pdfData: {
                  name: responseJson.data.bio.name,
                  dob: responseJson.data.bio.dob,
                  sex: responseJson.data.bio.sex,
                  age: age,
                  weight: responseJson.data.hospital_record.weight,
                  height: responseJson.data.hospital_record.height,
                  treatmentStartDate: responseJson.data.hospital_record.treatment_start_date,
                  siteOfDisease: responseJson.data.hospital_record.site_of_disease,
                  careGiver: responseJson.data.caregiver.name,
                  points: responseJson.data.progress.points,
                  treatmentNo: responseJson.data.hospital_record.treatment_no,
                  noOfSubmissions: 0,
                  adheranceRate: 0
                },
                csvData:  [
                  ['Name', responseJson.data.bio.name],
                  ['Project Number',  responseJson.data.hospital_record.treatment_no],
                  ['Age', age],
                  ['Sex', responseJson.data.bio.sex],
                  ['Weight', responseJson.data.hospital_record.weight],
                  ['Height', responseJson.data.hospital_record.height],
                  ['Treatment Start Date', responseJson.data.hospital_record.treatment_start_date],
                  ['Site of Disease', responseJson.data.hospital_record.site_of_disease],
                  ['Caregiver', responseJson.data.caregiver.name],
                  ['No of Submissions', 0],
                  ['Adherance Rate', 0 ]
                ]
            })
        })
        .catch((error)=>{
            console.error(error);
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
            }
			else if (error instanceof TypeError){
				console.log(error);
			}
            else{
                alert('something went wrong please try again later');
            }
        })
        this.checkPatientContacts();
        this.checkTestResults();
        this.fetchAppointments();
    }
    closeAlert(){
        localStorage.removeItem('new_patient');
        this.setState({ newPatient: false })
    }
    componentDidMount(){
        setTimeout(() => {
            this.closeAlert();
        }, 3500);
        this.LoadSummary();
    }
    componentWillUnmount(){
        this.closeAlert();
    }
    showModal(){
        this.setState({ show: true });
    };
    hideModal(){
        this.setState({ show: false });
    };
    closeNewAlert(){
        this.closeAlert();
    }
    closeContactsAlert(){
        this.checkPatientContacts();
    }
    LoadSummary = () => {
        let token = localStorage.getItem('access_token'),
            id = localStorage.getItem('user_id');

        let retries = 0;
        fetch(`${baseUrl}/admin/patients/month/${id}`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            if(response.status === 403){
                localStorage.removeItem('access_token');
                return <Redirect to='/login' />
            }
            return response.json();
        })
        .then((responseJson) => {
            this.setState({
                appointmentsNo: responseJson.appointments,
                vots: responseJson.vots,
            })
        })
        .catch((error)=>{
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
            }
			else if (error instanceof TypeError){
				console.log(error);
			}
            else{
                alert('something went wrong please try again later');
            }
        })
    }
    checkPatientContacts(){
        let token = localStorage.getItem('access_token'),
            id = localStorage.getItem('user_id');
        fetch(`${baseUrl}/admin/patients/contacts/${id}`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => response.json())
        .then((responseJson) => {
            if(responseJson.data.length === 0){
                this.setState({
                    noContactPersons: true
                })
            }else(
                this.setState({
                    noContactPersons: false
                })
            )
        })
    }
    checkTestResults = () => {
        let token = localStorage.getItem('access_token'),
            user_id = localStorage.getItem('user_id');
        fetch(`${baseUrl}/admin/patients/${user_id}/tests`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            return response.json();
        })
        .then((responseJson) => {
            if(responseJson.data.length === 0){
                this.setState({
                    noTestResult: true
                })
            }else(
                this.setState({
                    noTestResult: false
                })
            )
        })
    }
    fetchAppointments = () => {
        let token =  localStorage.getItem('access_token'),
            user_id = localStorage.getItem('user_id');
        fetch(`${baseUrl}/admin/patients/appointments/${user_id}`, {
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            return response.json();
        })
        .then((responseJson) => {
            this.setState({
                appointments: responseJson.data,
            })
        })
    }

    render(){
        const { appointmentsNo,  vots } = this.state;
        
        return(
            <div className="patient-profile">
                <div className="alerts-div">
                    {
                        this.state.newPatient &&
                        <div className="alert new">
                            <i className="fa fa-check-circle"></i>
                            <p>New user created successfully</p>
                            <i className="fa fa-times close-icon" onClick={this.closeNewAlert}></i>
                        </div>
                    }
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-8">
                            <Details details={this.state.details}/>
                            {
                                (this.state.noContactPersons || this.state.noTestResult) &&
                                <div className="warn">
                                    <i className="fa fa-exclamation-circle"></i>
                                    <div>
                                        <h6>Complete patient profile!</h6>
                                        <p>Complete information by <b>adding test results in Tests</b> tab or <b>contact persons in More Information</b> tab</p>
                                    </div>
                                </div>
                            }
                            {
                                this.state.response &&
                                <TabView>
                                    <p>Tests {this.state.noTestResult && <span className="incomplete">INCOMPLETE</span>}</p>
                                    <span>
                                        <Tests checkTests={this.checkTestResults}/>
                                    </span>
                                    <p>Treatment History</p>
                                    <span>
                                        {!this.state.noContactPersons? <TreatmentHistory id={this.state.id}/> : <DisplayMessage tab='treatment history' />}
                                    </span>
                                    <p>VOT Submissions</p>
                                    <span>
                                        {!this.state.noContactPersons? <VotSubmissions/> : <DisplayMessage tab='Vot submissions' />}
                                    </span>
                                    <p>More Information {this.state.noContactPersons && <span className="incomplete">INCOMPLETE</span>}</p>
                                    <span>
                                        <MoreInformation id={this.state.id} checkContacts={this.closeContactsAlert} details={this.state.details}/>
                                    </span>
                                </TabView>
                            }
                        </div>
                        <div className="col-sm-4">
                            <div className="appointments">
                                <h6>Appointments</h6>
                                <p>No appointments yet</p>
                            </div>
                            {
                                this.state.response &&
                                <div className="key-metrics">
                                    <h6>This Month</h6>
                                    <p><span>{appointmentsNo}</span>Appointments</p>
                                    <p><span>{vots}</span>VOT Submissions</p>
                                </div>
                            }
                            <div className="reward">
                                <h6>Reward Points</h6>
                                <p><span>{this.state.point}</span>Earned points</p>
                            </div>

                            <ExportContainer>
                                <h6>Export Users</h6>
                                <ExportButton
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    >
                                    <i className="fa fa-download"></i>
                                    <ExportButtonTitle>Export user data</ExportButtonTitle>
                                    <i className="fa fa-caret-down"></i>
                                    </ExportButton>
                                    <div
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                    >
                                    <div
                                    className="dropdown-item">
                                        <CSVLink filename={`${this.state.csvData[0][1]}_report.csv`} data={this.state.csvData}>Download as Spreadsheet</CSVLink>
                                    </div>
                                </div>
                            </ExportContainer>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PatientProfile;



// WEBPACK FOOTER //
// ./src/components/patientProfile/PatientProfile.js